// src/components/menuIconMap.js
// Outlined icon set (Ant Design) so every menu row looks consistent. Keys = backend module component / icon names.
import {
  ApartmentOutlined,
  AppstoreOutlined,
  AuditOutlined,
  BankOutlined,
  BellOutlined,
  BgColorsOutlined,
  BookOutlined,
  CalendarOutlined,
  CoffeeOutlined,
  CustomerServiceOutlined,
  DashboardOutlined,
  DollarOutlined,
  FileDoneOutlined,
  FileProtectOutlined,
  FileTextOutlined,
  GiftOutlined,
  GlobalOutlined,
  GroupOutlined,
  HomeOutlined,
  KeyOutlined,
  LineChartOutlined,
  PercentageOutlined,
  PictureOutlined,
  ProfileOutlined,
  SafetyCertificateOutlined,
  SafetyOutlined,
  ScheduleOutlined,
  SettingOutlined,
  TagsOutlined,
  TeamOutlined,
  ToolOutlined,
  UnorderedListOutlined,
  UserSwitchOutlined,
  UsergroupAddOutlined,
} from '@ant-design/icons';

const menuIconMap = {
  "SystemLogPage": ProfileOutlined,
  "AboutUsPage": BankOutlined,
  "FeaturesPage": CalendarOutlined,
  "PricingPage": AuditOutlined,
  "ContactUsPage": ToolOutlined,
  "CssEditorPage": BgColorsOutlined,
  "LandingPage": DashboardOutlined,
  "Login": UserSwitchOutlined,
  "Registration": UsergroupAddOutlined,
  "ResetPassword": SettingOutlined,
  "ForgotPassword": SettingOutlined,
  "Unauthorized": FileTextOutlined,
  "EmailConfirmation": PictureOutlined,
  "ResendConfirmationPage": PictureOutlined,
  "EmailConfirmationPendingPage": FileDoneOutlined,
  "SupportPage": CustomerServiceOutlined,
  "SupportAdminPage": CustomerServiceOutlined,
  "Dashboard": DashboardOutlined,
  "AdminDashboard": DashboardOutlined,
  "Settings": SettingOutlined,
  "SettingsPage": SettingOutlined,
  "ProfileSettingsPage": UserSwitchOutlined,
  "AccountSettingsPage": SettingOutlined,
  "HotelProfilePage": BankOutlined,
  "BookingListPage": BookOutlined,
  "BookingPage": BookOutlined,
  "CheckInOutPage": AuditOutlined,
  "CheckOut": AuditOutlined,
  "ReservationCalendarPage": ScheduleOutlined,
  "ReservationGantt": ScheduleOutlined,
  "RoomListPage": HomeOutlined,
  "RoomStatusPage": UnorderedListOutlined,
  "RoomMaintenancePage": ToolOutlined,
  "AmenitiesPage": AppstoreOutlined,
  "AmenitiesListPage": FileTextOutlined,
  "ActivitiesListPage": UsergroupAddOutlined,
  "EventsPage": CalendarOutlined,
  "EventsListPage": CalendarOutlined,
  "TasksPage": ProfileOutlined,
  "MaintenanceRequestsPage": ToolOutlined,
  "ReportsPage": FileDoneOutlined,
  "GuestListPage": TeamOutlined,
  "GuestProfilesPage": TeamOutlined,
  "ReservationReportsPage": FileDoneOutlined,
  "HousekeepingPage": ProfileOutlined,
  "HousekeepingReportsPage": ProfileOutlined,
  "GuestBillingPage": FileDoneOutlined,
  "FinancialReport": DollarOutlined,
  "BedTypesPage": HomeOutlined,
  "BookingTypesPage": UserSwitchOutlined,
  "RatesPage": PercentageOutlined,
  "RoomTypesPage": TagsOutlined,
  "HousekeeperDashboard": DashboardOutlined,
  "FloorPlansPage": GroupOutlined,
  "RoomImagesPage": PictureOutlined,
  "PromotionsPage": GiftOutlined,
  "ManageStaffPage": TeamOutlined,
  "AddStaffPage": UsergroupAddOutlined,
  "ModuleAssignment": ToolOutlined,
  "RoomQRPage": AuditOutlined,
  "ManageUsers": TeamOutlined,
  "FacilitiesPage": BankOutlined,
  "AddUserPage": UsergroupAddOutlined,
  "KYCVerificationPage": FileTextOutlined,
  "SetupHotelPage": SettingOutlined,
  "KYCUploadPage": FileTextOutlined,
  "KycReviewPage": FileTextOutlined,
  "HotelForm": BankOutlined,
  "RoomPricePage": DollarOutlined,
  "MaintenanceDashboard": DashboardOutlined,
  "MaintenancePage": ToolOutlined,
  "MaintenanceRequestForm": FileTextOutlined,
  "RestaurantOrderPage": CoffeeOutlined,
  "CreateServicePage": BellOutlined,
  "PermissionManager": KeyOutlined,
  "HotelSettings": SettingOutlined,
  "AdminLegalDocsPage": SafetyCertificateOutlined,
  "HotelAffiliationManagementPage": ApartmentOutlined,
  "HotelAgentApplicationsPage": FileProtectOutlined,
  "HotelAgentKycPage": SafetyOutlined,
  "HotelAgentCommissionsPage": PercentageOutlined,
  "AllAgentsKycPage": GlobalOutlined,
  "HotelSlaPage": LineChartOutlined,
};

export default menuIconMap;
